<template>
  <div style="width: 100%;" class="e-color-group-component">
    <div style="display: flex;flex-wrap: wrap;width: 100%;">
      <div class="color-block" v-for="(item, index) in colorList" :key="index">
        <div v-if="typeof item === 'string'" style="width: 100%;height: 100%" :style="{ backgroundColor: item }"
          @click="openPanel(index)"></div>
        <div v-else style="width: 100%;height: 100%" @click="showGradualDialog(item, index)"
          :style="{ backgroundImage: 'linear-gradient(' + item.colorStops[0].color + ',' + item.colorStops[1].color + ')' }">
        </div>
        <div class="color-block-bar">
          <div class="color-block-tool" @click.stop="removeColor(index)">-</div>
          <div class="color-block-tool" @click.stop="addColor(index)">+</div>
        </div>
      </div>
      <t-button shape="circle" variant="outline" @click="addColor(null)" v-show="colorList.length < props.max">
        <template #icon><t-icon name="add" /></template>
      </t-button>
    </div>
    <div style="position: relative;" v-if="showPanel">
      <div style="z-index: 9999999"
        :style="props.absolute ? { position: 'absolute', left: -90 + 'px', bottom: 4 + 'px' } : { marginLeft: -90 + 'px' }">
        <div style="position:relative;">
          <t-color-picker-panel size="small" :recentColors="null" :defaultRecentColors="null" :swatchColors="[]"
            enableAlpha :colorModes="['monochrome']" :format="props.format" v-model="colorList[currIndex]"
            @change="onChangeColor" />
          <div style="position: absolute;top:8px;z-index: 100;right:18px">
            <t-button v-show="props.gradient" variant="outline" size="small" @click="showGradualDialog(null, 0)"
              style="margin-right: 10px;">使用渐变色</t-button>
            <t-button variant="outline" size="small" @click="showPanel = false">关闭</t-button>
          </div>
        </div>
      </div>
    </div>
    <t-dialog header="配置颜色" v-model:visible="modelShow" @confirm="onConfirm(true)" cancelBtn="使用纯色"
      @cancel="onConfirm(false)">
      <div>
        <t-form>
          <t-form-item label="顶部">
            <t-color-picker style="width: 100%" :colorModes="['monochrome']" format="RGBA" v-model="tempGradualColor[0]"
              enableAlpha />
          </t-form-item>
          <t-form-item label="中部">
            <t-color-picker style="width: 100%" :colorModes="['monochrome']" format="RGBA" v-model="tempGradualColor[1]"
              enableAlpha />
          </t-form-item>
          <!-- <t-form-item label="底部">
            <t-color-picker style="width: 100%" :colorModes="['monochrome']" format="RGBA" v-model="tempGradualColor[2]"
              enableAlpha />
          </t-form-item> -->
        </t-form>
      </div>
    </t-dialog>
  </div>
</template>

<script setup>
import { ref, reactive, computed } from 'vue'
import { graphic } from 'echarts'

const props = defineProps({
  modelValue: { type: Array, default: () => [] },
  min: { type: Number, default: () => 1 },
  max: { type: Number, default: () => 10 },
  format: { type: String, default: () => 'HEX' },
  gradient: { type: Boolean, default: () => false },
  absolute: { type: Boolean, default: () => false },
})
const colorList = reactive(props.modelValue)
const showPanel = ref(false)
const currIndex = ref(-1)
const emit = defineEmits(['update:modelValue'])
const modelShow = ref(false)
const tempGradualColor = reactive(['#e9a90a', '#0bcfcf', '#cc0ce6', '#0aec0d'])

const onConfirm = (isGradient) => {
  let temp = tempGradualColor[0];
  if (isGradient) {
    temp = new graphic.LinearGradient(
      0, 0, 0, 1,
      [
        { offset: 0, color: tempGradualColor[0] },
        { offset: 1, color: tempGradualColor[1] },
        // { offset: 1, color: tempGradualColor[2] }
      ])
  }
  colorList.splice(currIndex.value, 1, temp)
  modelShow.value = false
  updateValue()
}
const showGradualDialog = (item, index) => {
  if (item) {
    tempGradualColor[0] = item.colorStops[0].color
    tempGradualColor[1] = item.colorStops[1].color
    // tempGradualColor[2] = item.colorStops[2].color
    currIndex.value = index
  }
  showPanel.value = false
  modelShow.value = true
}
const openPanel = (index) => {
  currIndex.value = index;
  showPanel.value = true;
}
const addColor = (index) => {
  if (colorList.length >= props.max) {
    return;
  }
  if (index === null) {
    colorList.push('#ccc')
    index = colorList.length - 1
  } else {
    index += 1
    colorList.splice(index, 0, '#ccc')
  }
  openPanel(index)
  updateValue()
}
const removeColor = (index) => {
  if (colorList.length <= props.min) {
    return;
  }
  colorList.splice(index, 1)
  showPanel.value = false;
  currIndex.value = 0;
  updateValue()
}
const updateValue = () => {
  emit('update:modelValue', colorList)
}
const onChangeColor = (color, type) => {

  colorList[currIndex.value] = type.color.css
}
</script>

<style scoped>
:deep(.t-select__wrap) {
  width: 72px;
}

.e-color-group-component .color-block {
  width: 30px;
  height: 30px;
  margin: 2px;
  cursor: pointer;
  text-align: center;
  position: relative;
  border-radius: 2px
}

.e-color-group-component .color-block-bar {
  position: absolute;
  width: 100%;
  height: 10px;
  top: -12px;
  text-align: right;
  line-height: 8px;
  display: none
}

.e-color-group-component .color-block-tool {
  display: inline-block;
  width: 10px;
  height: 100%;
  margin-left: 2px;
  text-align: center;
  border: 1px solid #ddd;
  border-radius: 10px
}

.e-color-group-component .color-block:hover .color-block-bar {
  display: block
}

:deep(.t-color-picker__body) {
  padding-top: 36px
}
</style>
